import { render, staticRenderFns } from "./ProcedimentosOrcados.vue?vue&type=template&id=e77e509c&scoped=true&"
import script from "./ProcedimentosOrcados.vue?vue&type=script&lang=js&"
export * from "./ProcedimentosOrcados.vue?vue&type=script&lang=js&"
import style0 from "./ProcedimentosOrcados.vue?vue&type=style&index=0&id=e77e509c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77e509c",
  null
  
)

export default component.exports